import React from 'react';
import DatasetAttachmentDeletionDialog from './DatasetAttachmentDeletionDialog';
import DatasetAttachmentEditDialog from './DatasetAttachmentEditDialog';
import DownloadableDatafileConfirmationDialog from './DownloadableDatafileConfirmationDialog';
import AssignDataToDictionaryDialog from './AssignDataToDictionaryDialog';
import Selectors from '../hooks/selectors';
import FolderDeletionDialog from './FolderDeletionDialog';
import FolderCreationDialog from './FolderCreationDialog';

const DatasetAttachmentDialogs = ({ theme }) => {
  const state = Selectors.useDatasetAttachmentDialogs();

  return (
    <>
      {state.allowCreate && <DownloadableDatafileConfirmationDialog theme={theme} />}
      {state.allowCreateFolder && <FolderCreationDialog theme={theme} />}
      {state.allowIngest && <AssignDataToDictionaryDialog theme={theme} />}
      {state.allowDelete && <DatasetAttachmentDeletionDialog theme={theme} />}
      {state.allowDeleteFolder && <FolderDeletionDialog theme={theme} />}
      {state.allowUpdate && <DatasetAttachmentEditDialog theme={theme} />}
    </>
  );
};

export default DatasetAttachmentDialogs;
